import React, { useEffect, useState } from "react";
import axiosInstance from "../Axiosinstance/AxiosInstance";
import ConfirmDeleteModal from "../common/ConfirmDeleteModal";

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const fetchLeads = async () => {
    try {
      const res = await axiosInstance.get("service/api/v1/contacts");
      setLeads(res.data || []);
      setLoading(false);
    } catch (err) {
      setError("Failed to fetch leads");
      setLoading(false);
    }
  };

  const openDeleteModal = (lead) => {
    setDeleteTarget(lead);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      setDeleting(true);
      await axiosInstance.delete(`service/api/v1/contacts/${deleteTarget.id}/`);
      setLeads((prev) => prev.filter((item) => item.id !== deleteTarget.id));
      setShowDeleteModal(false);
      setDeleteTarget(null);
    } catch (err) {
      alert("Failed to delete lead");
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  return (
 <div class="w-full min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900
  text-white py-4 sm:py-6 lg:py-8 2xl:selection:bg-blue-500/30 selection:bg-blue-500/30 px-4">
      <h1 className="text-3xl md:text-4xl font-bold mb-1 tracking-tight mb-6">Leads</h1>

      {loading && <p>Loading leads...</p>}
      {error && <p className="text-red-400">{error}</p>}

      {!loading && !error && (
        <div className="overflow-x-auto rounded-lg shadow-lg border border-gray-700">
          <table className="min-w-full text-left text-sm text-gray-300">
            <thead className="bg-gray-800 text-gray-200">
              <tr>
                <th className="p-3">ID</th>
                <th className="p-3">Name</th>
                <th className="p-3">Email</th>
                <th className="p-3">Phone</th>
                <th className="p-3">Message</th>
                <th className="p-3">Created At</th>
                <th className="p-3 text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {leads.map((lead) => (
                <tr key={lead.id} className="border-b border-gray-700 hover:bg-gray-800/60">
                  <td className="p-3">{lead.id}</td>
                  <td className="p-3">{lead.name}</td>
                  <td className="p-3">{lead.email}</td>
                  <td className="p-3">{lead.phone}</td>
                  <td className="p-3">{lead.message}</td>
                  <td className="p-3">{lead.createdAt}</td>
                  <td className="p-3 text-center">
                    <button
                      onClick={() => openDeleteModal(lead)}
                      className="bg-red-600 hover:bg-red-700 text-white px-4 py-1 rounded"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        title="Delete Lead"
        description={`Are you sure you want to delete lead "${deleteTarget?.name || "this lead"}"? This action cannot be undone.`}
        confirmLabel="Delete Lead"
        cancelLabel="Cancel"
        loading={deleting}
        onConfirm={handleConfirmDelete}
        onCancel={() => {
          if (deleting) return;
          setShowDeleteModal(false);
          setDeleteTarget(null);
        }}
      />
    </div>
  );
}